module.exports = __webpack_public_path__ + "87480e3d44c018beab79dd61ccb8b5df.svg";